import React from 'react';
import { Button } from 'semantic-ui-react';
import $ from "jquery";

import Title from '../../title';
import Transfer from '../../Accountings/Journal/transfer';
import GetDate from '../../../functions/date';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Voucher from './voucher';
import ChangeMode from '../receipt/changemode';
import Cancel from './cancel';
import CancelledData from '../receipt/cancelleddata'
class Receipt extends React.Component {

    state = {
        fromDate: GetDate(new Date(), 'fromDate'), //Set From Date
        toDate: GetDate(new Date(), 'toDate'), //Set To Date
        data: [], menuPermission: []
    }

    componentDidMount() {
        this.menuControl();
    }

    menuControl() {
        let menuPermission = Permission('machine-payment', this.props.menus);
        if (menuPermission.view) {
            this.getReceipt();
        }
        this.setState({ menuPermission })
    }

    getReceipt() {
        let context = this;
        $.ajax({
            type: 'POST', data: { type: 'payment' },
            url: Server()+'machine/receipt/get.php',
            success: function(data) {
                console.log(data);
                console.log('datatatat');
                try {
                    data = JSON.parse(data);
                    context.setState({ data, load: false })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    render() {
        let sino = 1;
        return (
            <div>
                <Title title='Machine Payment' openDrawer={this.props.openDrawer}/>
                { this.state.menuPermission.view ?
                    (
<div>
                    <div style={{display: 'flex', margin: '5px'}}>
                        <div>
                            <b>From Date</b><br/>
                            <input type="date" value={this.state.fromDate} style={{width: '100%', height: 35 }}
                                onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                        </div>
                        <div style={{marginLeft: '2px'}}>
                            <b>To Date</b><br/>
                            <input type="date" value={this.state.toDate} style={{width: '100%', height: 35 }}
                                onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                        </div>
                        <div style={{marginLeft: '2px'}}>
                            <br/>
                            <Button onClick={this.getReceipt.bind(this)}>Submit</Button>
                        </div>
                        <div style={{marginLeft: '2px'}}>
                            <br/>
                            { this.state.menuPermission.add ?
                                <Transfer type="Ledger" transferControl={this.state.transferControl}  />:''
                            }                       
                        </div>
                        <div style={{marginLeft: '2px'}}>
                            <br/>
                            <CancelledData refreshData={ () => { this.getReceipt() }} dialogTitle={'Cancelled Payment'} type="payment" />
                        </div>
                    </div>
                    <div style={{margin: '3px'}}>
                        <table id="table" width="100%">
                            <tr id="th">
                                <th>Sino</th>
                                <th>Receipt Voucher</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Mode</th>
                                <th>Voucher</th>
                                <th>Remarks</th>
                                { this.state.menuPermission.cancel ?
                                    <th>Cancel</th>:''
                                }
                            </tr>
                            {
                                this.state.data.map((c) => {
                                    return (
                                        <tr>
                                            <td>{sino++}</td>
                                            <td>{c.receipt_voucher}</td>
                                            <td>{c.name}</td>
                                            <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Rs. '+c.amount}</div></td>
                                            <td><center><ChangeMode menuPermission={this.state.menuPermission} mode={c.mode} id={c.id} refreshData={this.getReceipt.bind(this)} /></center></td>
                                            <td><center><Voucher menuPermission={this.state.menuPermission} refreshData={this.getReceipt.bind(this)} voucher={c.voucher}  id={c.id} /></center></td>
                                            <td>{c.remark}</td>
                                            { this.state.menuPermission.cancel ?
                                                <td><center><Cancel id={c.id} refreshData={this.getReceipt.bind(this)} /></center></td>:''
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </div>
                </div>
                    ):
                    (
                        <center>You ARe Not Alllow To Access This Menu</center>
                    )
                }
                
            </div>
        );
    }
}

export default Receipt;
